import React from 'react';
import { X } from 'lucide-react';

interface CookiePolicyProps {
  isOpen: boolean;
  onClose: () => void;
}

const CookiePolicy: React.FC<CookiePolicyProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[200] animate-fade-in">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-5xl mx-4 relative max-h-[80vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="sticky float-right right-4 top-4 text-gray-400 hover:text-gray-600 transition-colors bg-white rounded-full p-1 z-10"
        >
          <X size={24} />
        </button>

        <div className="p-8 pt-4">
          <h2 className="font-serif text-2xl font-bold text-primary-900 mb-6">Cookie Policy</h2>
          
          <div className="prose max-w-none">
            <p className="text-gray-600 mb-6">
              Last updated: {new Date().toLocaleDateString('en-GB')}
            </p>

            <section className="mb-8">
              <h3 className="text-xl font-semibold mb-4">1. What Are Cookies</h3>
              <p className="text-gray-600 mb-4">
                Cookies are small text files that are placed on your computer or mobile device when you visit our website. They are widely used to make websites work more efficiently and provide a better user experience.
              </p>
            </section>

            <section className="mb-8">
              <h3 className="text-xl font-semibold mb-4">2. How We Use Cookies</h3>
              <p className="text-gray-600 mb-4">
                We use cookies for the following purposes:
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-600">
                <li>Essential cookies: Required for the website to function properly</li>
                <li>Analytics cookies: To understand how visitors interact with our website</li>
                <li>Preference cookies: To remember your settings and preferences</li>
                <li>Marketing cookies: To deliver more relevant advertisements</li>
              </ul>
            </section>

            <section className="mb-8">
              <h3 className="text-xl font-semibold mb-4">3. Types of Cookies We Use</h3>
              <h4 className="font-medium mb-2">3.1 Essential Cookies</h4>
              <p className="text-gray-600 mb-4">
                These cookies are necessary for the website to function and cannot be switched off. They are usually only set in response to actions made by you which amount to a request for services.
              </p>

              <h4 className="font-medium mb-2">3.2 Analytics Cookies</h4>
              <p className="text-gray-600 mb-4">
                These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site.
              </p>

              <h4 className="font-medium mb-2">3.3 Functional Cookies</h4>
              <p className="text-gray-600 mb-4">
                These cookies enable the website to provide enhanced functionality and personalisation. They may be set by us or by third-party providers.
              </p>

              <h4 className="font-medium mb-2">3.4 Targeting Cookies</h4>
              <p className="text-gray-600 mb-4">
                These cookies may be set through our site by our advertising partners to build a profile of your interests.
              </p>
            </section>

            <section className="mb-8">
              <h3 className="text-xl font-semibold mb-4">4. Managing Cookies</h3>
              <p className="text-gray-600 mb-4">
                Most web browsers allow you to control cookies through their settings preferences. However, if you limit the ability of websites to set cookies, you may worsen your overall user experience.
              </p>
            </section>

            <section className="mb-8">
              <h3 className="text-xl font-semibold mb-4">5. Contact Us</h3>
              <p className="text-gray-600 mb-4">
                If you have any questions about our Cookie Policy, please contact us at:
              </p>
              <div className="text-gray-600">
                <p>SL Rooms Limited</p>
                <p>1 London Road</p>
                <p>Ipswich, Suffolk, IP1 2HA</p>
                <p>United Kingdom</p>
                <p>Email: info@slrooms.com</p>
                <p>Phone: +44 808 531 0127</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;